export default string =>
  String(string || '')
    .replace(/<script>.*(\s+.*)*<\/script>/gm, '')
    .replace(/<\/*(td|th|li|dt|dd)*>/gm, ' ')
    .replace(/<[^>]*>/gm, '')
    .replace(/ +/gm, ' ')
    .trim()
